import { withTranslation } from "next-i18next";
import { useState } from "react";
import ProductReviewsSharedPictureOffcanvas from "./ProductReviewsSharedPictureOffcanvas";

function ProductSharedPictures({ product, t }) {
  const [sharedPicturesOffcanvasOpened, setSharedPicturesOffcanvasOpened] = useState(false);
  const [selectedSharedPictureIndex, setSelectedSharedPictureIndex] = useState(0);

  function openSharedPicturesOffcanvas(index) {
    setSelectedSharedPictureIndex(index);
    setSharedPicturesOffcanvasOpened(true);
  }

  function closeSharedPicturesOffcanvas() {
    setSharedPicturesOffcanvasOpened(false);
    setSelectedSharedPictureIndex(0);
  }

  if (!product.recent_shared_pictures.length) return null;

  return (
    <section className="mb-4">
      <p className="mb-3 font-weight-bold">
        {t("product:community_pictures_title")}
      </p>

      <div className="product-shared-pictures-container">
        {product.recent_shared_pictures.map((sharedPicture, index) => (
          <button
            key={sharedPicture.id}
            onClick={() => openSharedPicturesOffcanvas(index)}
            className="btn-transparent product-shared-picture"
          >
            <img
              src={sharedPicture.image_url}
              className="w-100"
              alt=""
              loading="lazy"
            />
          </button>
        ))}
      </div>

      <ProductReviewsSharedPictureOffcanvas
        product={product}
        opened={sharedPicturesOffcanvasOpened}
        close={closeSharedPicturesOffcanvas}
        selectedSharedPictureIndex={selectedSharedPictureIndex}
      />
    </section>
  );
}

export default withTranslation("product")(ProductSharedPictures);
